import { z } from 'zod';
export const MyDevicesSearchSchema = z.object({
  page: z.number().default(1),
  pageSize: z.number().default(100)
});